/*
Copyright (c) 2021
*/

import constants from '../../constants';

const { REQUEST_PRE_EDITOR_DATA, PRE_EDITOR_DATA_RECEIVED } = constants.FieldPreEditorConstant;

export default {
  REQUEST_PRE_EDITOR_DATA,
  PRE_EDITOR_DATA_RECEIVED,
 

  requestGetAllTrimClips: payload => ({
    type: REQUEST_PRE_EDITOR_DATA,
    payload
  }),
  GetAllTrimClipsReceived: () => ({
    type: PRE_EDITOR_DATA_RECEIVED
  }),

  EditEditorTranscriptData: payload => ({
    type: UPDATE_EDITOR_TRANSCRIPT_DATA,
    payload
  })
};
